import React, { useState, useEffect } from 'react';
import Loader from '../../Search/Loader';
import Select from '../../Select';

const DriverDataBox = ({ driver }) => {
    const [loading, setLoading] = useState(true);
    const [driverId, setDriverId] = useState(driver);
    const [driverData, setDriverData] = useState([]);

    useEffect(() => {
        fetch(`${wp_ajax.db_ajax_url}?action=fetch_database_driver_data_box&driver_id=${driverId}`)
            .then(res => res.json())
            .then(response => {
                setDriverData(response.data);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <Loader />;
    }

    const toggleViewMore = e => {
        e.preventDefault();
        e.target.closest('.toggle').classList.toggle('open');
    };

    const handleSeasonsStatsChange = e => {
        const currentSeasonsStats = document.querySelectorAll('.database-data__seasons-stats.active');
        const seasonsStats = document.querySelector(`.database-data__seasons-stats[data-target="${e.target.options[e.target.selectedIndex].dataset.target}"]`);

        if (currentSeasonsStats.length > 0) {
            currentSeasonsStats.forEach(currentSeasonsStat => {
                currentSeasonsStat.classList.remove('active');
            });
        }

        if (seasonsStats !== null) {
            seasonsStats.classList.add('active');
        }
    };

    return (
        <div className="database-data proxima toggle">
            <div className="database-data__wrapper">
                {driverData.full_name && (
                    <>
                        <div className="database-data__head">Full name</div>
                        <div className="database-data__content">{driverData.full_name}</div>
                    </>
                )}
                {driverData.born && (
                    <>
                        <div className="database-data__head">Born</div>
                        <div className="database-data__content">{driverData.born}</div>
                    </>
                )}
                {driverData.died && (
                    <>
                        <div className="database-data__head">Died</div>
                        <div className="database-data__content">{driverData.died}</div>
                    </>
                )}
                {driverData.nationality && (
                    <>
                        <div className="database-data__head">Nationality</div>
                        <div className="database-data__content database-data__icon"
                             dangerouslySetInnerHTML={{ __html: driverData.nationality }}></div>
                    </>
                )}
                {driverData.recent_race && (
                    <>
                        <div className="database-data__head">Recent Race</div>
                        <div className="database-data__content">
                            <a href={driverData.recent_race.url}>
                                {driverData.recent_race.post_title}
                            </a>
                        </div>
                    </>
                )}
                {driverData.seasons_stats && driverData.seasons_stats.length > 0 && (
                    <>
                        <div className="database-data__head">Series</div>
                        {driverData.cross_site ? (
                            <div className="database-data__content">
                                {driverData.seasons_stats.map((stat, i) => (        
                                    <span key={i}>{stat.series}</span>
                                ))}
                            </div>
                        ) : (
                            <div className="database-data__content database-data__select easyselect easyselect--transparent">
                                <Select
                                    name="driver-seasons-stats"
                                    id="driver-seasons-stats"
                                    default={driverData.seasons_stats[0].series_slug}
                                    onChange={handleSeasonsStatsChange}
                                    options={driverData.seasons_stats.map((stat, i) => (        
                                        <option key={i} data-target={stat.series_slug}>
                                            {stat.series}
                                        </option>
                                    ))}
                                />
                            </div>
                        )}
                        {driverData.seasons_stats.map((stat, i) => (        
                            <div key={i} data-target={stat.series_slug}
                                 className={'database-data__seasons-stats' + (i === 0 ? ' active' : '')}>
                                {stat.years_raced && (
                                    <>
                                        <div className="database-data__head">Years in Database</div>
                                        <div className="database-data__content">
                                            {stat.years_raced}
                                        </div>
                                    </>
                                )}
                                {stat.starts && (
                                    <>
                                        <div className="database-data__head">Starts</div>
                                        <div className="database-data__content">
                                            {stat.starts + (stat.fails > 0 ? ' (' + stat.fails + ')' : '')}
                                        </div>
                                    </>
                                )}
                                {stat.wins && (
                                    <>
                                        <div className="database-data__head">Wins</div>
                                        <div className="database-data__content">
                                            {stat.wins}
                                        </div>
                                    </>
                                )} 
                                {stat.poles && (
                                    <>
                                        <div className="database-data__head">Poles</div>
                                        <div className="database-data__content">
                                            {stat.poles}
                                        </div>
                                    </>
                                )}
                                {stat.podiums && (
                                    <>
                                        <div className="database-data__head">Podiums</div>
                                        <div className="database-data__content">
                                            {stat.podiums}
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </>
                )}
                <div className="database-data__expand">
                    <a href="#" className="database-data__more" onClick={toggleViewMore}>View More</a>
                    <a href="#" className="database-data__less" onClick={toggleViewMore}>View Less</a>
                </div>
            </div>
        </div>
    );
};

export default DriverDataBox;
